export default __webpack_public_path__ + "static/media/dev-avan-jses6.fb4ee9ac.png";